import { type ReactNode } from "react";
import { VideoCallingHookProvider, type VideoCallingSession } from "@tellescope/video-calling";
import { useEnduserAuth, useVideoCalling } from "../store";
import { VideoCallDialog } from "../components/VideoCallDialog";

interface VideoCallingProviderProps {
  children: ReactNode;
}

/**
 * Video calling provider for portal-web.
 *
 * Wraps children with VideoCallingHookProvider to inject the hook and session.
 * Renders the VideoCallDialog when a video call is active.
 */
export function VideoCallingProvider({ children }: VideoCallingProviderProps) {
  const { session } = useEnduserAuth();
  const videoCalling = useVideoCalling();

  // Cast session to VideoCallingSession - EnduserSession has compatible API methods at runtime
  const videoSession = session as unknown as VideoCallingSession | null;

  return (
    <VideoCallingHookProvider useVideoCalling={useVideoCalling} session={videoSession}>
      {children}
      {videoCalling.isVisible && (
        <VideoCallDialog
          calendarEventId={videoCalling.meetingMeta.calendarEventId}
          eventTitle={videoCalling.meetingMeta.eventTitle ?? undefined}
          onClose={() => videoCalling.setIsVisible(false)}
        />
      )}
    </VideoCallingHookProvider>
  );
}
